<template>
  <tr>
    <td>{{ !extra ? item.work_type.name : item.work_extra_type.name }}</td>
    <td v-if="!edit">
      {{
        !extra
          ? item.work_type.is_hourly == 0
            ? (item.size ? $roundNumberToTenths(item.size) : '0') + ' ' + item.work_type.measure
            : $formatTime(item.hours || 0) +
              (item.size
                ? ' (' + $roundNumberToTenths(item.size) + ' ' + item.work_type.measure + ')'
                : '')
          : $formatTime(item.hours)
      }}
    </td>
    <td v-else>
      <div class="grid">
        <BaseInput
          v-if="extra || item.work_type.is_hourly == 1"
          v-model="time"
          inputType="time"
          :rules="['required']"
        />
        <BaseInput
          :width="200"
          v-if="!extra"
          v-model="item.size"
          inputType="number"
          :rules="item.work_type.is_hourly == 0 ? ['required'] : []"
        >
          <template v-slot:append-outer>{{ item.work_type.measure }}</template>
        </BaseInput>
      </div>
    </td>
    <td class="note">
      <BaseInput
          v-if="edit"
          v-model="item.report"
      />
      <template v-else>
        {{ item.report ? item.report : '—' }}
      </template>
    </td>
    <td>
      <div class="buttons">
        <DeleteModal
          v-if="
            $userCheckAccess({
              abilities: 'edit_work_days',
            })
          "
          ref="deleteModal"
          :text="
            localStorage.translations.pages.projects.reports_dialogs.delete_report +
            ' ' +
            (!extra ? item.work_type.name : item.work_extra_type.name)
          "
          :methodDelete="onDeleteItem"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import DeleteModal from 'components/DeleteModal'
import { mapActions, mapGetters } from 'vuex'
import BaseInput from "components/base/BaseInput";
export default {
  name: 'TimeControlShowEmployeeDayTableItem',
  components: {BaseInput, DeleteModal },
  props: { item: Object, extra: Boolean, edit: Boolean, functionUpdate: Function },
  data: () => ({
    open: false,
    time: null,
  }),
  watch: {
    time() {
      if (this.time.length) {
        const [hours, minutes] = this.time.split(':')
        this.item.hours = parseInt(hours) * 60 + parseInt(minutes)
      } else {
        this.item.hours = null
      }
    },
    edit() {
      this.time = this.$formatTimeMin(this.item.hours)
    },
  },
  methods: {
    ...mapActions('employeeWorkDay', [
      'onEmployeeWorkDay_periodReport_delete',
      'onEmployeeWorkDay_extra_delete',
    ]),
    onDeleteItem() {
      this[
        !this.extra ? 'onEmployeeWorkDay_periodReport_delete' : 'onEmployeeWorkDay_extra_delete'
      ](this.item.id)
        .then((response) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
              IsError: false,
            },

            { root: true },
          )
          this.$refs.deleteModal.dialog = false
          this.functionUpdate({ calendar: true })
        })
        .catch((err) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
  },
}
</script>

<style lang="scss" scoped>
td {
  &.note {
    word-wrap: break-word;
  }
  .grid {
    display: grid;
    gap: 10px;
  }
  &:nth-child(1) {
    width: calc(100% / 3);
  }
  &:nth-child(2) {
    width: calc(100% / 3);
  }
  &:nth-child(3) {
    width: calc(100% / 3);
  }
  &:nth-child(4) {
    width: 100px;
  }
}
</style>
